import {API_LOGIN, API_LOGIN_NB, API_CREATE_USER_NB, API_WHOAMI, API_LOGOUT, API_UPDATE_ME, API_UPDATE_PROFILE, API_CLIENT, API_TECH} from '../config';
import { switch_api } from './switch_api';

export function userIsLoading(bool) {
  return {
    type: 'USER_IS_LOGGING_IN',
    userIsLoading: bool
  }
}

export function userLoggedInSuccess(fields) {
  return {
    type: 'USER_LOGGED_IN_SUCCESS',
    fields
  }
}

export function userLoggedInFailure(message) {
  return {
    type: 'USER_LOGGED_IN_ERROR',
    message
  }
}

export function userLogoutFailure(message) {
  return {
    type: 'USER_LOGOUT_ERROR',
    message
  }
}


export function userLogoutSuccess(fields) {
  return {
    type: 'USER_LOGOUT_SUCCESS',
    fields
  }
}

export function userUpdateProfileSuccess(fields) {
  return {
    type: 'USER_UPDATE_PROFILE_SUCCESS',
    fields
  }
}

export function initializeUser() {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    dispatch(userIsLoading(true));
    fetch(API_WHOAMI, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_WHOAMI }: " + response.statusText);
        dispatch(userIsLoading(false));
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => dispatch(userLoggedInSuccess(fields)))
    .then((fields) => {
      fields.username ? 
        (fields.is_client ? localStorage.setItem('API', API_CLIENT) : localStorage.setItem('API', API_TECH)) : null
    })
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
      dispatch(userIsLoading(false));
    })
  }
}

export function updateUser(data) {
  let token =  localStorage.getItem('token')
  return (dispatch) => {
    fetch(switch_api(API_UPDATE_ME), {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify(data)
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_UPDATE_ME }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => dispatch(userUpdateProfileSuccess(fields)))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

export function updateProfile(data) {
  let token =  localStorage.getItem('token')
  console.warn(data)
  return (dispatch) => {
    fetch(switch_api(API_UPDATE_PROFILE), {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify(data)
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_UPDATE_ME }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => console.warn(fields))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }
}

// NB == new backend
async function createUserNB (token, email, login, password, is_supervisor)
{
  const role = is_supervisor ? 'supervisor' : 'technician';
  const services_token_refresh =
    await fetch
    (
      API_CREATE_USER_NB,

      {
        method: 'POST',

        headers:
        {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${ token }`,
        },

        body:
          JSON.stringify
          ({
            email,
            login,
            password,
            role,
          }),
      },
    )
    .then
    (
      (response) =>
      {
        if (!response.ok)
        {
          // console.error('');

          return response.text();
        }

        return response.json();
      }
    )
    .then
    (
      (json) =>
      {
        if (json.refresh)
        {
          return json.refresh;
        }

        return null;
      },
    );

  if (services_token_refresh)
  {
    localStorage.setItem('services_token_refresh', services_token_refresh);
  }
}

async function loginUserNB (login, password, email, is_supervisor = false)
{
  const token_temp =
    await fetch
    (
      API_LOGIN_NB,

      {
        method: 'POST',

        headers:
        {
          Accept: 'application/json',

          'Content-Type': 'application/json; charset=utf-8',

          // Authorization: `Basic ${ btoa(`${ login }:${ password }`) }`,
          Authorization: 'Basic bW9kZWxlcl91aUAzZC1zbWlsZS5ydTprWDZkSFA1Yg==',
        },
      },
    )
    .then
    (
      (response) =>
      {
        if (!response.ok)
        {
          // console.error('');

          return response.text();
        }

        return response.json();
      }
    )
    .then
    (
      (json) =>
      {
        if (json.access)
        {
          return json.access;
        }

        return null;
      },
    );

  if (token_temp)
  {
    // await createUserNB(token_temp, email || login, login, password, is_supervisor);
    await createUserNB2(token_temp, email || login, login, password, is_supervisor);
  }
}

export function loginUser(login, password) {
  return (dispatch) => {
    fetch(API_LOGIN, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Basic '+btoa(login+':'+password),
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      // credentials: 'include',
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_LOGIN }: " + response.statusText);
        // throw Error(response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((fields) => dispatch(fields.token ? (
        localStorage.setItem('token',fields.token ),
        userLoggedInSuccess(fields)
      ) : userLoggedInFailure(fields.detail))
    )
    .then(async (fields) => {
      await loginUserNB(
        login,
        password,
        fields.fields.user && fields.fields.user.email,
        fields.fields.user.is_supervisor // role
      );

      fields.fields.user ?
        (fields.fields.user.is_client ? localStorage.setItem('API', API_CLIENT) : localStorage.setItem('API', API_TECH)) : null
    })
    .catch((e) => {
      dispatch(userLoggedInFailure(' '))
    })
  }
}

async function createUserNB2 (token, email, login, password, is_supervisor)
{
  const role = is_supervisor ? 'supervisor' : 'technician';
  const services_tokens =
    await fetch
    (
      API_CREATE_USER_NB,

      {
        method: 'POST',

        headers:
        {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${ token }`,
        },

        body:
          JSON.stringify
          ({
            email,
            login,
            password,
            role,
          }),
      },
    )
    .then
    (
      (response) =>
      {
        if (!response.ok)
        {
          // console.error('');

          return response.text();
        }

        return response.json();
      }
    )
    .then
    (
      (json) =>
      {

        if (json.access && json.refresh)
        {
          return [ json.access, json.refresh ];
        }

        return null;
      },
    );

  if (services_tokens)
  {
    localStorage.setItem('services_token', services_tokens[0]);
    localStorage.setItem('services_token_refresh', services_tokens[1]);
  }
}


export function logoutUser() {
  let token =  localStorage.getItem('token')
  return (dispatch, getState) => {
    fetch(API_LOGOUT, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include' // send cookies for CORS requests
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed logging out on { API_LOGOUT}");
        throw Error(response.statusText);
      }
      return response;
    })
    // .then((response) => response.json())
    .then((response) => dispatch(userLogoutSuccess()))
    .catch((err) => dispatch(userLogoutFailure('logout failure: ' + err)))
  }
}





// WEBPACK FOOTER //
// ./src/actions/auth.js